import { useEffect, RefObject, ReactElement } from 'react';

type Props = {
  setVisibility: (isVisible: boolean) => void;
  element: RefObject<HTMLElement>;
  children: ReactElement;
};

function ToggableList({ setVisibility, element, children }: Props) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (element.current && !element.current.contains(event.target as Node | null)) {
        setVisibility(false);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [element, setVisibility]);

  return children;
}

export default ToggableList;
